/* eslint-disable class-methods-use-this */
import { customElement } from 'lit/decorators.js';
import { CustomerAttribute } from '@mfec/customerAttributes/types';
import { TefComsCustomerAttributeBase } from '@mfec/customerAttributes/TefComsCustomerAttributeBase';
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import comsStore from '@mfe-4cs/state/ComsStore';
import { IReactionDisposer, reaction } from 'mobx';
import { templates } from './templates'; // eslint-disable-line import/no-cycle

@customElement('tef-coms-customer-attribute')
export class TefComsCustomerAttribute extends TemplatingMixin(TefComsCustomerAttributeBase, 'occl', templates) {
  private disposer: IReactionDisposer;

  constructor() {
    super();
    this.disposer = reaction(() => this.customerAttributes, () => {
      this.requestUpdate();
    });
  }

  connectedCallback() {
    super.connectedCallback();
    // Only available here after store init and not on top of the class :(
    this.setTemplatingTheme(this.theme);
  }

  disconnectedCallback() {
    this.disposer();
  }

  get customerAttributes() {
    return comsStore.customerAttributes ?? [];
  }

  get theme() {
    return comsStore.config?.occlUri ? 'occl' : 'tefOne';
  }

  get userIsInRegisterFlow() {
    return !!comsStore.config?.isNewCustomer;
  }

  get userIsInEditMode() {
    return true;
  }

  saveCustomerAttributeToStore(customerAttribute: CustomerAttribute): void {
    comsStore.setCustomerAttribute(customerAttribute);
  }

  getTemplateFnFor(templateName: string) {
    return this.getTemplateFn(templateName);
  }

  get mainComponentTag() {
    return 'tef-coms4cs';
  }
}
